'use strict';

const libPictView = require('pict-view');
const libShared = require('./ProjectContractTypes-Shared.js');

/**
 * ContractTypes — the #/ContractTypes management screen. A thin view over the shared ProjectContractTypes provider
 * (activated in Contract mode). Logic/state live in the provider; this view just lays out the rail/detail shell.
 */
class ContractTypes extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
	}

	get provider() { return this.pict.providers.ProjectContractTypes; }

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider) { tmpProvider.activate('Contract'); }
		return super.onAfterRender(pRenderable);
	}
}

module.exports = ContractTypes;
module.exports.default_configuration =
{
	ViewIdentifier: 'ContractTypes',
	DefaultRenderable: 'ContractTypesWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	CSS: libShared.CSS,
	Templates:
	[
		{
			Hash: 'ContractTypes-Wrap',
			Template: libShared.wrapTemplate('Contract Types', 'Create and edit contract types, then set up each one’s template — statuses, default dates, allowed project types, default funding — that new contracts are cloned from.'),
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'ContractTypesWrap',
			TemplateHash: 'ContractTypes-Wrap',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
			RenderMethod: 'replace',
		},
	],
};
